import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SAVE,
  SAVE_SUCCESS,
  SAVE_FAILED,
  CLONE,
  CLONE_SUCCESS,
  CLONE_FAILED,
  CREATE_NEW_COMPANY,
  CREATE_NEW_COMPANY_FAILED,
  CREATE_NEW_COMPANY_SUCCESS,
} from './constants';

export const initAction = () => ({ type: INIT });
export const initSuccessAction = () => ({ type: INIT_SUCCESS });
export const initFailedAction = (error, errorCode) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export const cloneCompanyAction = (data) => ({
  type: CLONE,
  data,
});
export const cloneSuccessAction = () => ({ type: CLONE_SUCCESS });
export const cloneFailedAction = (error, errorCode, additional) => ({
  type: CLONE_FAILED,
  error,
  errorCode,
  ...additional,
});

export const createNewCompanyAction = (data) => ({
  type: CREATE_NEW_COMPANY,
  data,
});
export const createNewCompanySuccessAction = () => ({
  type: CREATE_NEW_COMPANY_SUCCESS,
});
export const createNewCompanyFailedAction = (error, errorCode, additional) => ({
  type: CREATE_NEW_COMPANY_FAILED,
  error,
  errorCode,
  ...additional,
});

export const saveAction = (data) => ({
  type: SAVE,
  data,
});
export const saveSuccessAction = () => ({ type: SAVE_SUCCESS });
export const saveFailedAction = (error, errorCode, additional) => ({
  type: SAVE_FAILED,
  error,
  errorCode,
  ...additional,
});
